<template>
    <div class="product-edit-vehicules" v-loading="loader">
        <fieldset class="form-fieldset">
            <legend>Ajouter un ou des véhicules</legend>
            <div class="row">
                <div class="col-lg-7">
                    <el-cascader ref="cascaderVehicule" class="full-width" clearable filterable change-on-select :props="{label: 'label', value: 'value'}" v-model="addVehiculeInput" :options="vehiculeOptions" placeholder="Véhicule"></el-cascader>
                </div>
                <div class="col-lg-5 text-right">
                    <button @click.prevent="addVehicule" class="btn btn-outline-success ml-3">Ajouter</button>
                    <button @click.prevent="addVehiculeAll" class="btn btn-link text-warning ml-3">Ajouter tous les véhicules</button>
                </div>
            </div>
        </fieldset>

        <div class="row">
            <div class="col-lg-6">
                <el-pagination @current-change="goToPage"  layout="prev, pager, next" :total="metaPagination.total" :page-size="metaPagination.per_page"></el-pagination>
            </div>
            <div class="col-lg-6 text-right">
                <button @click.prevent="goToPage(1)" class="btn btn-link btn-sm ml-3">Rafraichir la liste</button>
                <button @click.prevent="removeAll" class="btn btn-link text-danger btn-sm ml-3">Supprimer tous les véhicules</button>
            </div>
        </div>

        <hr>

        <el-table style="width: 100%" ref="multipleTableVehicules" :data="vehicules" stripe>
            <el-table-column label="Marque">
                <template slot-scope="scope">
                    {{ scope.row.brand.name }}
                </template>
            </el-table-column>
            <el-table-column label="Cylindrer">
                <template slot-scope="scope" >
                    {{ scope.row.cylinder }}
                </template>
            </el-table-column>
            <el-table-column label="Model">
                <template slot-scope="scope" >
                    {{ scope.row.model }}
                </template>
            </el-table-column>
            <el-table-column label="Année">
                <template slot-scope="scope" >
                    {{ scope.row.year }}
                </template>
            </el-table-column>
            <el-table-column label="Action">
                <template slot-scope="scope" >
                    <el-dropdown @command=" command => remove(command, scope.row)">
                        <el-button type="danger" size="mini">
                            Supprimer<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu  slot="dropdown">
                            <el-dropdown-item command="row">la ligne</el-dropdown-item>
                            <el-dropdown-item command="year">tout de cette année</el-dropdown-item>
                            <el-dropdown-item command="model">tout de ce model</el-dropdown-item>
                            <el-dropdown-item command="cylinder">tout de ce cylindre</el-dropdown-item>
                            <el-dropdown-item command="brand">tout de cette marque</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            loader: false,
            vehicules: [],
            vehiculeOptions: [],
            addVehiculeInput: [],
            metaPagination: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 20,
                total: 0,
            },
        }
    },
    props: {
        product: {
            required: true
        }
    },
    computed: {
        productId() {
            return this.product.id;
        }
    },
    watch: {
        productId(newV, oldV) {
            this.goToPage(1)
        }
    },
    created() {

    },
    mounted() {
        axios.get('/vehicules?cascader=1').then(r => {
            this.vehiculeOptions = r.data.data;
        });
        this.goToPage(1)
    },
    methods: {
        fetch(params) {
            return axios.get('/products/'+this.product.id+'/vehicules', {params}).then((r)=>{
                this.vehicules = r.data.data
                this.metaPagination  = r.data.meta;
            })
        },
        goToPage(p) {
            this.loader = true
            this.fetch({page:p}).then(()=>{
                this.loader = false
            })
        },
        addVehiculeAll() {
            this.$confirm('Ajouter tous les véhicules ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                this.loader = true;
                var datas = {
                    mode: 'associateVehiculeAll'
                };
                axios
                    .post('/products/'+this.product.id, datas)
                    .then(r => {
                        this.$store.dispatch('products/updateInList', {id: this.product.id, data:r.data.data})
                        this.goToPage(1)
                        this.addVehiculeInput = []
                        this.$notify.info({
                            title: 'Opération en cours',
                            message: 'Étant donné le nombre de véhicule, l\'opération peut prendre plusieurs minutes.'
                        });
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loader = false;
                    });
            }).catch(()=>{

            })

        },
        addVehicule() {
            if (!this.addVehiculeInput.length) {
                return;
            }
            this.loader = true;
            var vehicule = this.addVehiculeInput
            var datas = {
                vehicule,
                mode: 'associateVehicule'
            };
            axios
                .post('/products/'+this.product.id, datas)
                .then(r => {
                    this.$store.dispatch('products/updateInList', {id: this.product.id, data:r.data.data})
                    this.goToPage(1)
                    this.addVehiculeInput = []
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },
        remove(command, vehicule) {
            var warningMessage = {
                row: 'Enlever uniquement ce véhicule de cette ligne ?',
                cylinder: 'Enlever tous les véhicules de cette cylindrer de cette marque ?',
                model: 'Enlever tous les véhicules de ce modél de cette marque ?',
                year: 'Enlever tous les véhicules de cette années de cette marque ?',
                brand: 'Enlever tous les véhicules de cette marque ?',
            }

            this.$confirm(warningMessage[command], 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                this.loader = true;
                var datas = {
                    scope: command,
                    mode: 'dissociateVehicule'
                };
                axios
                    .post('/products/'+this.product.id+'/vehicules/'+vehicule.id, datas)
                    .then(r => {
                        this.$store.dispatch('products/updateInList', {id: this.product.id, data:r.data.data})
                        this.product =  this.product.update(r.data.data);
                        this.addVehiculeInput = []
                        this.goToPage(1)
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loader = false;
                    });

            }).catch(()=>{})

        },
        removeAll() {
            this.$confirm('Supprimer tous les véhicules ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                this.loader = true;
                var datas = {
                    mode: 'dissociateVehiculeAll'
                };
                axios
                    .post('/products/'+this.product.id, datas)
                    .then(r => {
                        this.$store.dispatch('products/updateInList', {id: this.product.id, data:r.data.data})
                        this.goToPage(1)
                        this.addVehiculeInput = []
                        this.$notify.info({
                            title: 'Opération en cours',
                            message: 'Étant donné le nombre de véhicule, l\'opération peut prendre plusieurs minutes.'
                        });
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loader = false;
                    });

            }).catch(()=>{})
        }
    }
}
</script>
<style lang="scss">
    .product-edit-vehicules {

    }
</style>
